import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import environment from "../../utils/Environment";
import { getGemsTokenContract } from "../../utils/contractHelpers";
import Web3 from "web3";
import Environment from "../../utils/Environment";

export const GetGemsBalance = () => {
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);

  const GetGemsBal = useCallback(
    async (account, tokenAddress, decimals) => {
      // console.log(tokenAddress, 'busd');

      // const tokenAddress = environment.gems;
      const contract = getGemsTokenContract(tokenAddress, web3);
      const approved = await contract.methods
        .balanceOf(account?.toString())
        .call();
      const bal = parseInt(approved.toString()) / 10 ** decimals;
      return bal;
    },
    [web3],
  );

  return { GetGemsBal: GetGemsBal };
};

export default GetGemsBalance;
